import React, { forwardRef } from 'react';

const CustomInput = forwardRef(({ 
  type, 
  id, 
  name, 
  placeholder, 
  bg, 
  border, 
  place,
  characterLimit,
  onInputChange,
  defaultValue,
  ...rest 
}, ref) => {
  const today = new Date().toISOString().split('T')[0];
  
  const handleChange = (e) => {
    if (type === 'date') {
      e.target.value = e.target.value;
    }
    if (onInputChange) onInputChange(e); // Prop to handle external events
    
  };

  return (
    <input
      ref={ref}
      type={type}
      id={id}
      name={name}
      maxLength={characterLimit}
      onChange={handleChange}
      className={`w-full px-[1.5rem] py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey ${bg} ${border}`}
      placeholder={placeholder}
      defaultValue={defaultValue}
      {...rest}
    />
  );
});

export { CustomInput };